import {
    GptAdSlotDefinition,
    SizeMapping,
    SlotSize,
    SlotSizeArray,
} from '@news-mono/web-common'
import React from 'react'

export const DisplaySizeMapping: React.FC<{ sizeMapping: SizeMapping }> = ({
    sizeMapping,
}) => (
    <li>
        {formatAdSlot(sizeMapping.slot)} @ width &gt;= {sizeMapping.viewport[0]}
    </li>
)

export const ViewSizeMappings: React.FC<{ unit: GptAdSlotDefinition }> = ({
    unit,
}) => (
    <ul>
        {unit.sizeMapping
            ? unit.sizeMapping
                  .sort((a, b) => (a.viewport[0] < b.viewport[0] ? 1 : -1))
                  .map((sm, i) => (
                      <DisplaySizeMapping key={i} sizeMapping={sm} />
                  ))
            : 'unknown'}
    </ul>
)

export function formatAdSlot(adSlot: SlotSize): string {
    if (adSlot.length === 0) {
        return 'None'
    }

    if (typeof adSlot[0] === 'string') {
        return adSlot.join(', ')
    }
    if (typeof adSlot[0] === 'number') {
        // Include consideration for video mapping
        if (adSlot.length === 3 && adSlot[2] === 'v') {
            return `${adSlot[0]}x${adSlot[1]}v`
        }

        // If the adSlot is a single size, return it as a string
        return `${adSlot[0]}x${adSlot[1]}`
    }

    // Need a cast here as type narrowing doesn't work with above checks
    return (adSlot as SlotSizeArray)
        .map((slot) => formatAdSlot(slot))
        .join(', ')
}
